import React from "react";
import { Button } from "react-bootstrap";
import {
    StyledModal,
    StyledModalBody,
    StyledModalFooter,

} from "../../../../Styling/styledModal/styledModals";


const BekreftFlytting = (props) => {

    const messages = props.fbFuncs.messages    

    return (

        <StyledModal centered show={true} onHide={props.fbFuncs.cancelHandler}>

            <StyledModalBody>
                <h4>{messages.BE_Move_Header}</h4>
                <p style={{whiteSpace: "pre-line"}}>{props.fbFuncs.confirmMoveMessage}</p>
            </StyledModalBody>
           
            <StyledModalFooter>
                <Button variant="secondary" onClick={props.fbFuncs.okHandler}>
                    {messages.BE_Ja}
                </Button>
                <Button variant="secondary" onClick={props.fbFuncs.cancelHandler}>
                    {messages.BE_Nei}
                </Button>
            </StyledModalFooter>

        </StyledModal>
    );
};

export default BekreftFlytting;